export default __webpack_public_path__ + "static/beach-img-811efbc72571b12e2ef04aa5e3c37689.jpeg";